export default [
  {
    name: 'Los Angeles',
    long: -118.256243,
    lat: 34.044949,
    orientation: 'left',
  },
  {
    name: 'San Diego',
    long: -117.148962,
    lat: 32.69247,
    orientation: 'left',
  },
  {
    name: 'Sacramento',
    long: -121.494444,
    lat: 38.581667,
    orientation: 'right',
  },
  {
    name: 'San Francisco',
    long: -122.416389,
    lat: 37.7775,
    orientation: 'left',
  },
  {
    name: 'Redding',
    long: -122.366667,
    lat: 40.583333,
    orientation: 'right',
  },
  {
    name: 'Fresno',
    long: -119.766667,
    lat: 36.75,
    orientation: 'right',
  },
];
